import React from 'react';

const Footer = () => (
    <footer className="footer-container">
        <p>© 2020 Code & Design by <a href="https://mehdipilehvarian.dev/" className="footer-link">Mehdi Pilehvarian</a></p>
    </footer>
);

export default Footer;